import { useTranslations } from 'next-intl';
import {
  JobBenefitOptionFragment,
  JobCrewCategoryOptionFragment,
} from '../gen/graphql/JobsRoute.generated';
import { useI18nLabel } from '@/hooks/useI18nLabel';
import { PrefectureValue } from '@/constants/prefectures';
import { useMemo } from 'react';
import { Option } from '@/types/options';

export interface UseFormatTitleProps {
  prefecture?: Option<PrefectureValue>;
  jobCategory?: JobCrewCategoryOptionFragment;
  jobBenefit?: JobBenefitOptionFragment;
}

export function useFormatTitle({
  prefecture,
  jobCategory,
  jobBenefit,
}: UseFormatTitleProps): string {
  const t = useTranslations();
  const translate = useI18nLabel();

  return useMemo(() => {
    const conditions = [
      prefecture?.label ?? undefined,
      jobCategory ? translate(jobCategory) : undefined,
      jobBenefit ? translate(jobBenefit) : undefined,
    ].filter((condition) => !!condition);

    if (conditions.length === 0) {
      return t('jobs.title');
    }

    return t('jobs.titleWithConditions', {
      conditions: conditions.join('、'),
    });
  }, [prefecture, jobCategory, jobBenefit, t, translate]);
}
